import React, { Component } from 'react'
import { connect } from 'react-redux'
import WithAuth from '../../../HOCs/WithAuth'
import { Button, Tabs, Tab } from 'react-bootstrap'
import { PulseLoader } from 'react-spinners'
import { withAlert } from 'react-alert'
import '../style.css'

import {
  getIncompleteCharts,
  getChartCounts,
} from '../reducers/chartsReducer'

import {
  handleChartPhaseChange,
  submitChartGeneralInfo,
  getChart,
  toggleChartRequiresRevisions,
  toggleChartApproved,
  toggleChartCompleted,
  chartHasBeenCompleted,
  deleteChart,
  isChartCompleted,
  handleChartFieldChange,
  alertChartHasBeenSaved,
  toggleChartApprovedBySite,
  toggleChartApprovedByDataManager,
} from '../reducers/chartFormReducer'

import { submitChartDemographicsInfo } from '../reducers/patientDemographicsFormReducer'

import { submitChartHospitalAdmissionInfo } from '../reducers/hospitalAdmissionFormReducer'

import { addInfectionCourse, submitChartPathogenInfo } from '../reducers/infectionCourseFormReducer'

import { submitChartAntibioticsUse } from '../reducers/antibioticsUseFormReducer'

import { submitChartHospitalizationOutcome } from '../reducers/hospitalizationOutcomeFormReducer'

import LoadingScreen from '../../../components/LoadingScreen'
import ConfirmationPopover from '../../../components/ConfirmationPopover'

import IncompleteChartsModal from './IncompleteChartsModal'
import NewChartConfirmationModal from "./NewChartConfirmationModal"
import ChartInCompleteOnSubmitModal from './ChartInCompleteOnSubmitModal'
import DateValidationOverrideModal from './DateValidationOverrideModal'
import ScreeningFailureModal from './ScreeningFailureModal'
import ChartReviewNotesModal from './ChartReviewNotesModal'

import ChartBasicInfo from './ChartBasicInfo'
import PatientDemographicsForm from './PatientDemographicsForm'
import HospitalAdmissionForm from './HospitalAdmissionForm'
import InfectionCourseForm from './InfectionCourseForm'
import AntibioticsUseForm from './AntibioticsUseForm'
import HospitalizationOutcomeForm from './HospitalizationOutcomeForm'
import ChartFormPhase from './ChartFormPhase'

class ChartFormContainer extends Component {
  state = {
    showIncompleteChartsModal: false,
    activeKey: 'General',
    showScreeningFailureModal: false,
    showDateValidationOverrideModal: false,
    isSavingAndFinishing: false,
    showChartReviewNotesModal: false,
  }


  componentDidMount() {
    const {
      patientChartUrl,
      chartForReview,
      chartForRevision,
      chartApproved,
      incompleteCharts,
      routerProps,
      screeningFailure,
      isChartCompleted,
      chartIsReadOnly,
    } = this.props

    this.props.getChartCounts(this.props.alert)

    if (patientChartUrl && !chartForReview && !chartForRevision && !chartApproved && screeningFailure) {
      isChartCompleted(this.props, screeningFailure)
    }

    if ((chartForReview || chartForRevision) && patientChartUrl) {
      this.props.handleChartPhaseChange(1)
    }

    if (chartForReview || chartForRevision || chartApproved || chartIsReadOnly) {
      return this.props.getChart(routerProps, true)
    }

    if (!chartForReview && !patientChartUrl && !chartApproved && incompleteCharts.length === 0 ) {
      this.props.getIncompleteCharts()
    }

    if (screeningFailure) {
      this.setState({ showScreeningFailureModal: true })
    }
  }


  componentDidUpdate(prevProps, prevState) {
    if (this.props.incompleteCharts.length > 0 && prevProps.incompleteCharts.length === 0) {
      this.setState({ showIncompleteChartsModal: true })
    }

    if (this.props.patientChartUrl && !prevProps.patientChartUrl) {
      this.setState({ showIncompleteChartsModal: false })
    }

    if (!prevProps.patientChartErrorMessage && this.props.patientChartErrorMessage) {
      this.props.alert.show(this.props.patientChartErrorMessage)
    }

    if (!prevProps.triggerDateOverrideModal && this.props.triggerDateOverrideModal) {
      this.setState({
        showDateValidationOverrideModal: !this.state.showDateValidationOverrideModal
      })
    }

    if (prevProps.screeningFailure !== this.props.screeningFailure && this.props.screeningFailure) {
      this.props.isChartCompleted(this.props, this.props.screeningFailure)
      this.setState({ showScreeningFailureModal: true })
    }

    if (this.props.reviewDataManagerNotes && prevProps.fetchingChart &&!this.props.fetchingChart && !this.props.errorFetchingChart) {
      this.toggleShowChartReviewNotesModal(true)
    }
  }

  componentWillUnmount() {
    return this.props.chartHasBeenCompleted()
  }

  changeTab = (activeKey) => {
    // activeKey should be one of the following strings, which corresponds with a section of the chart and a section of the chart review notes:
    // 'General'
    // 'Demographics'
    // 'Hospital Admission'
    // 'Infection/Microbiology'
    // 'Antibiotics'
    // 'Outcome'
    window.scrollTo(0, 0)
    this.setState({ activeKey })
  }

  handleSave = () => {
    if (this.state.activeKey === 'General') {
      return this.props.submitChartGeneralInfo(this.props)
    } else if (this.state.activeKey === 'Demographics') {
      return this.props.submitChartDemographicsInfo(this.props)
    } else if (this.state.activeKey === 'Hospital Admission') {
      return this.props.submitChartHospitalAdmissionInfo(this.props)
    } else if (this.state.activeKey === 'Infection/Microbiology') {
      return this.props.addInfectionCourse(this.props)
    } else if (this.state.activeKey === 'Antibiotics') {
      return this.props.submitChartAntibioticsUse(this.props, null, true)
    } else if (this.state.activeKey === 'Outcome') {
      return this.props.submitChartHospitalizationOutcome(this.props)
    }
  }

  handleSaveAndFinish = () => {
    if (this.props.chartForRevision) {
      this.setState({ isSavingAndFinishing: true }, () => {
        this.props.toggleChartRequiresRevisions(this.props, false)
      })
    } else {
      this.setState({ isSavingAndFinishing: true }, () => {
        this.props.isChartCompleted(this.props)
      })
    }
  }

  toggleSaveAndFinishOnModalClose = () => this.setState({ isSavingAndFinishing: false })

  toggleShowIncompleteCharts = () => {
    this.setState({ showIncompleteChartsModal: !this.state.showIncompleteChartsModal })
  }

  toggleShowDateValidationOverrideModal = () => {
    this.setState({ showDateValidationOverrideModal: !this.state.showDateValidationOverrideModal })
  }

  toggleShowIncompleteChartOnSubmit = () => {
    return this.props.handleChartFieldChange('chartIsIncompleteModalShow', !this.props.chartIsIncompleteModalShow)
  }

  toggleShowScreeningFailureModal = () => {
    this.setState({ showScreeningFailureModal: !this.state.showScreeningFailureModal })
  }

  getDataForOverrideModal = () => {
    let data = null
    if (this.props.hospitalAdmissionDateOverride !== null) {
      data = {model: 'HospitalAdmission', modelData: this.props.hospitalAdmissionDateOverride}
      return data
    } else if (this.props.antibioticsUseDateOverride !== null) {
      data = {model: 'AntibioticsUse', modelData: this.props.antibioticsUseDateOverride}
      return data
    } else if (this.props.infectionCourseDateOverride !== null) {
      data = {model: 'InfectionCourse', modelData: this.props.infectionCourseDateOverride}
      return data
    } else if (this.props.pathogenDateOverride !== null) {
      data = {model: 'Pathogen', modelData: this.props.pathogenDateOverride}
      return data
    } else {
      return data
    }
  }

  resetDateValidationOverrideModal = (data) => {
    let keyToReset
    if (data['model'] === "HospitalAdmission") {
      keyToReset = 'hospitalAdmissionDateOverride'
    } else if (data['model'] === "AntibioticsUse") {
      keyToReset = 'antibioticsUseDateOverride'
    } else if (data['model'] === "InfectionCourse") {
      keyToReset = 'infectionCourseDateOverride'
    } else if (data['model'] === 'Pathogen') {
      keyToReset = 'pathogenDateOverride'
    }
    return this.props.handleChartFieldChange(keyToReset, null)
  }

  chartReviewPopoverContent = () => {
    return (
      <div>
        <p>
          If the chart requires revisions, click the <strong>'Requires Revisions'</strong> button to notify the chart's creator. Your notes will be sent to the original chart creator to inform them on how to fix any errors in the chart. Notes can be accessed by clicking the 'Show Notes' button at the top of this page. Please make sure that you have added any necessary notes before proceeding.
        </p>
        <p>
          If the chart is approved, click the <strong>'Chart Approved'</strong> button to finish.
        </p>

      </div>
    )
  }

  reviewDataManagerNotesPopoverContent = () => {
    return (
      <div>
        <p>
          The data manager has requested validation for this chart. If you have reviewed the data manager's notes and determined that the the chart requires revisions, click the <strong>'Requires Revisions'</strong> button to notify the chart's creator. Please add any notes you think would be helpful in guiding the original chart creator. Notes can be accessed by clicking the 'Show Notes' button at the top of this page.
        </p>
        <p>
          If the data in the chart is correct, click the <strong>'Chart Verified'</strong> button to finish. You may want to reply to the data manager's notes by clicking the 'Show Notes' button and navigating to the relevent section.
        </p>

      </div>
    )
  }

  dataManagerReviewPopoverContent = () => {
    return (
      <div>
        <p>
          If any data in the chart requires validation, click the <strong>'Requires Validation'</strong> button to notify the site's investigator(s). Your notes will be sent to the site's investigator(s) to inform them on how to validate or fix any errors in the chart. Notes can be accessed by clicking the 'Show Notes' button at the top of this page. Please make sure that you have added any necessary notes before proceeding.
        </p>
        <p>
          If the chart is approved, click the <strong>'Chart Approved'</strong> button to finish.
        </p>

      </div>
    )
  }

  saveAndFinishPopoverContent = () => {
    return (
      <div>
        <p>
          Before proceeding, please make sure that <strong>all sections of the chart</strong> have been completed.
        </p>
      </div>
    )
  }


  deleteChartPopoverContent = () => {
    return (
      <div>
        <p>
          Deleting this chart will <strong>permanently remove all of its data from the database</strong>.
        </p>
        <p>
          <strong>This action is irreversible.</strong>.
        </p>

        <p>Are you sure that you wish to proceed?</p>
      </div>
    )
  }

  antibioticsUseScreeningFailure = () => {
    if (this.props.screeningFailure) {
      let diff =  Math.floor(( Date.parse(this.props.cefiderocolInitiationDate) - Date.parse(this.props.cefiderocolEndDate) ) / 86400000)
      if (Math.abs(diff) < 3) {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }

  handleChartApprovedBySite = () => {
    this.setState({ isSavingAndFinishing: true }, () => {
      this.props.toggleChartApprovedBySite(this.props, true)
    })
  }

  toggleShowChartReviewNotesModal = (showChartReviewNotesModal) => this.setState({ showChartReviewNotesModal })


  render() {
    const {
      savingChartPhase,
      chartForReview,
      chartForRevision,
      currentUser,
      chartCreatedBy,
      chartCompleted,
      deletingChart,
      chartApproved,
      screeningFailure,
      chartDateErrorMessage,
      routerProps,
      chartIsReadOnly,
     } = this.props

    const showDeleteButton = !chartCompleted && currentUser && currentUser.url === chartCreatedBy

    if (this.props.fetchingIncompleteCharts || this.props.fetchingChartCounts) {
      return <LoadingScreen text='Loading' />
    }

    if ((this.props.chartCounts.approved_chart_count >= 20 && process.env.REACT_APP_MODE !== "DEMO") && (this.props.routerProps.location.pathname === "/charts/new")) {
      return <NewChartConfirmationModal show={ true } routerProps={ this.props.routerProps } />
    }

    if (this.props.fetchingChart) {
      return <LoadingScreen text='Loading chart' />
    }

    if (!this.props.fetchingChart && this.props.errorFetchingChart) {
      return (
        <div className='ChartsContainer'>
          {this.props.errorFetchingChartMessage ?
            <center>
              <h5>
                {this.props.errorFetchingChartMessage}
              </h5>
            </center>
            :
            <center>
              <h5>
                There was an error retrieving the chart from the server.
              </h5>
              <br />
              <h5>
                Please refresh the page to try again.
              </h5>
            </center>
          }
        </div>
      )
    }

    const showFinishChartButton = !chartApproved && !chartForReview && this.props.patientChartUrl ? true : false

    return (
      <div className='ChartsContainer'>
        <div className="buttons-footer">
          <div className='buttons-row'>
            <div className="buttons-to-right">

              {chartIsReadOnly ?
                null
                :
                <Button
                  variant='primary'
                  className='chart-phase-button'
                  onClick={() => routerProps.history.replace('/home')}
                  disabled={savingChartPhase || deletingChart}
                >
                  {savingChartPhase ?
                    <PulseLoader
                      css={`display: block; margin: 0 auto;`}
                      color='white'
                    />
                    :
                    'Exit Chart'
                  }
                </Button>
              }

              {showDeleteButton ?
                <ConfirmationPopover
                  triggerText={deletingChart || savingChartPhase ?
                    <PulseLoader
                      css={`display: block; margin: 0 auto;`}
                      color='white'
                    />
                    :
                    'Delete Chart'
                  }

                  title='Delete Chart'
                  placement='top'
                  popoverContent={this.deleteChartPopoverContent()}
                  cancelText='Cancel'
                  confirmText='Delete Chart'
                  confirmButtonVariant='danger'
                  onCancel={() => null}
                  onConfirm={() => this.props.deleteChart(this.props.patientChartUrl, this.props)}
                  triggerButtonClass='chart-phase-button'
                  triggerVariant='danger'
                  popoverClassName="delete-chart-popover"
                  disabled={savingChartPhase || deletingChart}
                />
                :
                null
              }
              {!chartForReview && !chartApproved && !chartIsReadOnly ?
                <Button
                  variant='primary'
                  className='chart-phase-button'
                  disabled={savingChartPhase || deletingChart}
                  onClick={this.handleSave}
                >
                  {savingChartPhase ?
                    <PulseLoader
                      css={`display: block; margin: 0 auto;`}
                      color='white'
                    />
                    :
                    'Save Progress'
                  }
                </Button>
                :
                null
              }

              {(showFinishChartButton || screeningFailure) && !chartForReview && !chartApproved && !chartIsReadOnly ?

                <ConfirmationPopover
                  triggerText={savingChartPhase ?
                    <PulseLoader
                      css={`display: block; margin: 0 auto;`}
                      color='white'
                    />
                    :
                    'Submit Chart'
                  }
                  title='Save and Finish Chart'
                  placement='top'
                  popoverContent={this.saveAndFinishPopoverContent()}
                  cancelText='Cancel'
                  confirmText='Save and Finish'
                  confirmButtonVariant='success'
                  onCancel={() => null}
                  onConfirm={this.handleSaveAndFinish}
                  triggerButtonClass='chart-phase-button'
                  triggerVariant='success'
                  disabled={savingChartPhase || deletingChart}
                />
                :
                null
              }

              {/* Chart Approved Buttons */}

              {chartApproved || chartIsReadOnly?
                <Button
                  onClick={() => {
                    const path = routerProps.match.path.replace('/:id', '')
                    routerProps.history.push(path)
                  }}
                  className="chart-phase-button"
                >
                  Back
                </Button>
                :
                null
              }

              {/* Chart Review Buttons */}

              {chartForReview && routerProps.match.path === '/charts/review/:id' ?
                <ConfirmationPopover
                  triggerText={savingChartPhase ?
                    <PulseLoader
                      css={`display: block; margin: 0 auto;`}
                      color='white'
                    />
                    :
                    'Finish Reviewing'
                  }

                  title='Finish Reviewing Chart'
                  placement='top'
                  popoverContent={this.chartReviewPopoverContent()}
                  cancelText='Chart Approved'
                  confirmText='Requires Revisions'
                  onCancel={this.handleChartApprovedBySite}
                  onConfirm={() => this.props.toggleChartRequiresRevisions(this.props, true)}
                  triggerButtonClass='chart-phase-button'
                  triggerVariant='success'
                />
                :
                null
              }

              {/* Review Data Manager Notes Buttons */}

              {chartForReview && routerProps.match.path === '/charts/review-data-manager-notes/:id' ?
                <ConfirmationPopover
                  triggerText={savingChartPhase ?
                    <PulseLoader
                      css={`display: block; margin: 0 auto;`}
                      color='white'
                    />
                    :
                    'Finish Reviewing'
                  }

                  title='Finish Reviewing Chart'
                  placement='top'
                  popoverContent={this.reviewDataManagerNotesPopoverContent()}
                  cancelText='Chart Verified'
                  confirmText='Requires Revisions'
                  onCancel={this.handleChartApprovedBySite}
                  onConfirm={() => this.props.toggleChartApprovedBySite(this.props, false)}
                  triggerButtonClass='chart-phase-button'
                  triggerVariant='success'
                />
                :
                null
              }

              {/* Data Manager Review Buttons */}

              {chartForReview && routerProps.match.path === '/charts/validate/:id' ?
                <ConfirmationPopover
                  triggerText={savingChartPhase ?
                    <PulseLoader
                      css={`display: block; margin: 0 auto;`}
                      color='white'
                    />
                    :
                    'Finish Reviewing'
                  }

                  title='Finish Reviewing Chart'
                  placement='top'
                  popoverContent={this.dataManagerReviewPopoverContent()}
                  cancelText='Chart Approved'
                  confirmText='Requires Validation'
                  onCancel={() => this.props.toggleChartApprovedByDataManager(this.props, true)}
                  onConfirm={() => this.props.toggleChartRequiresRevisions(this.props, true)}
                  triggerButtonClass='chart-phase-button'
                  triggerVariant='success'
                />
                :
                null
              }
            </div>
          </div>
        </div>
        <IncompleteChartsModal
          show={this.state.showIncompleteChartsModal}
          toggleShow={this.toggleShowIncompleteCharts}
          {...this.props}
        />

        {
          this.state.isSavingAndFinishing
          ?
            <ChartInCompleteOnSubmitModal
              show={this.props.chartIsIncompleteModalShow}
              data={this.props.chartIsIncompleteModalData}
              chartIncompleteDuringApprovalProcess={this.props.chartIncompleteDuringApprovalProcess}
              toggleShow={this.toggleShowIncompleteChartOnSubmit}
              toggleSaveAndFinishOnModalClose={ this.toggleSaveAndFinishOnModalClose }
              {...this.props}
            />
           :
            null
        }


        {this.state.showDateValidationOverrideModal ?
          <DateValidationOverrideModal
            show={this.state.showDateValidationOverrideModal}
            errorMessage={chartDateErrorMessage ? chartDateErrorMessage.split('[')[0] : ""}
            toggleShow={this.toggleShowDateValidationOverrideModal}
            data={this.getDataForOverrideModal()}
            resetDateValidationOverrideModal={this.resetDateValidationOverrideModal}
            {...this.props}
          />
          :
          null
        }

        <ScreeningFailureModal
          savingChartPhase={this.props.savingChartPhase}
          show={this.state.showScreeningFailureModal}
          data={this.props.chartIsIncompleteModalData}
          toggleShow={this.toggleShowScreeningFailureModal}
          toggleSaveAndFinishOnModalClose={ () => null }
          // toggleSaveAndFinishOnModalClose={ this.toggleSaveAndFinishOnModalClose }
          patientChartUrl={this.props.patientChartUrl}
          routerProps={routerProps}
          // temporaryAdverseEvents={this.props.temporaryAdverseEvents}
        />

        <ChartReviewNotesModal
          show={this.state.showChartReviewNotesModal}
          chartForReview={chartForReview}
          chartForRevision={chartForRevision}
          notesSection={this.state.activeKey}
          readOnly={this.props.notesAreReadOnly}
          reviewDataManagerNotes={this.props.reviewDataManagerNotes}
          toggleShowChartReviewNotesModal={this.toggleShowChartReviewNotesModal}
        />

        <Tabs
          activeKey={this.state.activeKey}
          onSelect={this.changeTab}
        >
          <Tab eventKey='General' title="General">
            <ChartFormPhase
              title='General Information'
              chartForm={<ChartBasicInfo chartForReview={chartForReview || chartApproved || chartIsReadOnly} />}
              revisionNotes={this.props.generalChartNotes}
              notesAreReadOnly={this.props.notesAreReadOnly}
              chartIsReadOnly={this.props.chartIsReadOnly}
              chartForReview={chartForReview}
              chartForRevision={chartForRevision}
              reviewDataManagerNotes={this.props.reviewDataManagerNotes}
              notesSection='General'
              toggleShowChartReviewNotesModal={this.toggleShowChartReviewNotesModal}
              showChartReviewNotesModal={this.state.showChartReviewNotesModal}
            />
          </Tab>

          <Tab
            eventKey='Demographics'
            title={this.props.patientChartUrl ? 'Demographics' : null}
            disabled={!this.props.patientChartUrl}
          >
            <ChartFormPhase
              title='Patient Demographics'
              chartForm={<PatientDemographicsForm chartForReview={chartForReview || chartApproved || chartIsReadOnly} />}
              revisionNotes={this.props.patientDemographicsNotes}
              notesAreReadOnly={this.props.notesAreReadOnly}
              chartIsReadOnly={this.props.chartIsReadOnly}
              chartForReview={chartForReview}
              chartForRevision={chartForRevision}
              reviewDataManagerNotes={this.props.reviewDataManagerNotes}
              notesSection='Demographics'
              toggleShowChartReviewNotesModal={this.toggleShowChartReviewNotesModal}
              showChartReviewNotesModal={this.state.showChartReviewNotesModal}
            />
          </Tab>

          <Tab
            eventKey='Hospital Admission'
            title={this.props.patientChartUrl ? "Hospital Admission" : null}
            disabled={!this.props.patientChartUrl}
          >
            <ChartFormPhase
              title='Hospital Admission'
              chartForm={<HospitalAdmissionForm chartForReview={chartForReview || chartApproved || chartIsReadOnly} />}
              revisionNotes={this.props.hospitalAdmissionNotes}
              notesAreReadOnly={this.props.notesAreReadOnly}
              chartIsReadOnly={this.props.chartIsReadOnly}
              chartForReview={chartForReview}
              chartForRevision={chartForRevision}
              reviewDataManagerNotes={this.props.reviewDataManagerNotes}
              notesSection='Hospital Admission'
              toggleShowChartReviewNotesModal={this.toggleShowChartReviewNotesModal}
              showChartReviewNotesModal={this.state.showChartReviewNotesModal}
            />
          </Tab>

          <Tab
            eventKey='Infection/Microbiology'
            title={this.props.patientChartUrl ? "Infection/Microbiology" : null}
            disabled={!this.props.patientChartUrl}
          >
            <ChartFormPhase
              title='Infection Course / Microbiology'
              chartForm={<InfectionCourseForm chartForReview={chartForReview || chartApproved || chartIsReadOnly}               toggleShowScreeningFailureModal={this.toggleShowScreeningFailureModal} />}
              revisionNotes={this.props.infectionCourseNotes}
              notesAreReadOnly={this.props.notesAreReadOnly}
              chartIsReadOnly={this.props.chartIsReadOnly}
              chartForReview={chartForReview}
              chartForRevision={chartForRevision}
              reviewDataManagerNotes={this.props.reviewDataManagerNotes}
              notesSection='Infection/Microbiology'
              toggleShowChartReviewNotesModal={this.toggleShowChartReviewNotesModal}
              showChartReviewNotesModal={this.state.showChartReviewNotesModal}
            />
          </Tab>

          <Tab
            eventKey='Antibiotics'
            title={this.props.patientChartUrl ? "Antibiotics" : null}
            disabled={!this.props.patientChartUrl || this.antibioticsUseScreeningFailure()}
          >
            <ChartFormPhase
              title='Antibiotics Use'
              chartForm={<AntibioticsUseForm chartForReview={chartForReview || chartApproved || chartIsReadOnly} alert={this.props.alert}/>}
              revisionNotes={this.props.antibioticsUseNotes}
              notesAreReadOnly={this.props.notesAreReadOnly}
              chartIsReadOnly={this.props.chartIsReadOnly}
              chartForReview={chartForReview}
              chartForRevision={chartForRevision}
              reviewDataManagerNotes={this.props.reviewDataManagerNotes}
              cefiderocolAdverseEvents={this.props.cefiderocolAdverseEvents}
              notesSection='Antibiotics'
              toggleShowChartReviewNotesModal={this.toggleShowChartReviewNotesModal}
              showChartReviewNotesModal={this.state.showChartReviewNotesModal}
            />
          </Tab>

          <Tab
            eventKey='Outcome'
            title={this.props.patientChartUrl ? "Outcome" : null}
            disabled={!this.props.patientChartUrl || screeningFailure}
          >
            <ChartFormPhase
              title='Hospitalization Outcome'
              chartForm={<HospitalizationOutcomeForm chartForReview={chartForReview || chartApproved || chartIsReadOnly} />}
              revisionNotes={this.props.hospitalizationOutcomeNotes}
              notesAreReadOnly={this.props.notesAreReadOnly}
              chartIsReadOnly={this.props.chartIsReadOnly}
              chartForReview={chartForReview}
              chartForRevision={chartForRevision}
              reviewDataManagerNotes={this.props.reviewDataManagerNotes}
              notesSection='Outcome'
              toggleShowChartReviewNotesModal={this.toggleShowChartReviewNotesModal}
              showChartReviewNotesModal={this.state.showChartReviewNotesModal}
            />
          </Tab>
        </Tabs>


        <br/>

      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    // UNFINISHED CHARTS
    incompleteCharts: state.chartsReducer.incompleteCharts,
    fetchingIncompleteCharts: state.chartsReducer.fetchingIncompleteCharts,
    chartCounts: state.chartsReducer.chartCounts,
    fetchingChartCounts: state.chartsReducer.fetchingChartCounts,

    // USER
    currentUser: state.loginReducer.currentUser,

    // MISC
    chartPhase: state.chartFormReducer.chartPhase,
    savingChartPhase: state.chartFormReducer.savingChartPhase,
    fetchingChart: state.chartFormReducer.fetchingChart,
    errorFetchingChart: state.chartFormReducer.errorFetchingChart,
    errorFetchingChartMessage: state.chartFormReducer.errorFetchingChartMessage,
    chartCreatedBy: state.chartFormReducer.chartCreatedBy,
    chartCompleted: state.chartFormReducer.chartCompleted,
    screeningFailure: state.chartFormReducer.screeningFailure,
    deletingChart: state.chartFormReducer.deletingChart,
    chartIsIncompleteModalShow: state.chartFormReducer.chartIsIncompleteModalShow,
    chartIsIncompleteModalData: state.chartFormReducer.chartIsIncompleteModalData,
    chartIncompleteDuringApprovalProcess: state.chartFormReducer.chartIncompleteDuringApprovalProcess,

    // DATE VALIDATION
    triggerDateOverrideModal: state.chartFormReducer.triggerDateOverrideModal,
    hospitalAdmissionDateOverride: state.chartFormReducer.hospitalAdmissionDateOverride,
    antibioticsUseDateOverride: state.chartFormReducer.antibioticsUseDateOverride,
    infectionCourseDateOverride: state.chartFormReducer.infectionCourseDateOverride,
    pathogenDateOverride: state.chartFormReducer.pathogenDateOverride,
    
    // ERROR MESSAGES
    chartDateErrorMessage: state.chartFormReducer.chartDateErrorMessage,
    patientChartErrorMessage: state.chartFormReducer.patientChartErrorMessage,

    // PHASE ONE - BASIC CHART INFO
    trialSiteNumber: state.chartFormReducer.trialSiteNumber,
    chartReviewerId: state.chartFormReducer.chartReviewerId,
    chartReviewerRole: state.chartFormReducer.chartReviewerRole,
    chartReviewerRoleOther: state.chartFormReducer.chartReviewerRoleOther,
    patientIdentifier: state.chartFormReducer.patientIdentifier,
    site: state.chartFormReducer.site,
    patientChartUrl: state.chartFormReducer.patientChartUrl,
    metInclusionCriteria: state.chartFormReducer.metInclusionCriteria,
    metExclusionCriteria: state.chartFormReducer.metExclusionCriteria,
    informedConsentDate: state.chartFormReducer.informedConsentDate,
    localRequirementsExemption: state.chartFormReducer.localRequirementsExemption,

    // PHASE TWO - DEMOGRAPHICS
    age: state.patientDemographicsFormReducer.age,
    gender: state.patientDemographicsFormReducer.gender,
    race: state.patientDemographicsFormReducer.race,
    countryOfBirth: state.patientDemographicsFormReducer.countryOfBirth,
    placeOfResidence: state.patientDemographicsFormReducer.placeOfResidence,
    placeOfResidenceOther: state.patientDemographicsFormReducer.placeOfResidenceOther,
    demographicsInfoUrl: state.patientDemographicsFormReducer.demographicsInfoUrl,

    // PHASE THREE - HOSPITAL ADMISSION
    hospitalAdmissionInfoUrl: state.hospitalAdmissionFormReducer.hospitalAdmissionInfoUrl,
    admissionDate: state.hospitalAdmissionFormReducer.admissionDate,
    admissionType: state.hospitalAdmissionFormReducer.admissionType,
    admissionTypeOtherText: state.hospitalAdmissionFormReducer.admissionTypeOtherText,
    admissionDiagnoses: state.hospitalAdmissionFormReducer.admissionDiagnoses,
    myocardialInfarction: state.hospitalAdmissionFormReducer.myocardialInfarction,
    congestiveHeartFailure: state.hospitalAdmissionFormReducer.congestiveHeartFailure,
    peripheralVascularDisease: state.hospitalAdmissionFormReducer.peripheralVascularDisease,
    cerebrovascularDiseaseTransientIschemicAttacks: state.hospitalAdmissionFormReducer.cerebrovascularDiseaseTransientIschemicAttacks,
    dementia: state.hospitalAdmissionFormReducer.dementia,
    chronicPulmonaryDisease: state.hospitalAdmissionFormReducer.chronicPulmonaryDisease,
    connectiveTissueDisease: state.hospitalAdmissionFormReducer.connectiveTissueDisease,
    pepticUlcerDisease: state.hospitalAdmissionFormReducer.pepticUlcerDisease,
    mildLiverDisease: state.hospitalAdmissionFormReducer.mildLiverDisease,
    moderateSevereLiverDisease: state.hospitalAdmissionFormReducer.moderateSevereLiverDisease,
    diabetesMellitusUncomplicated: state.hospitalAdmissionFormReducer.diabetesMellitusUncomplicated,
    diabetesWithEndOrganDamage: state.hospitalAdmissionFormReducer.diabetesWithEndOrganDamage,
    hemiplegia: state.hospitalAdmissionFormReducer.hemiplegia,
    moderateOrSevereRenalDisease: state.hospitalAdmissionFormReducer.moderateOrSevereRenalDisease,
    solidTumorWithoutMetastasisLastFiveYears: state.hospitalAdmissionFormReducer.solidTumorWithoutMetastasisLastFiveYears,
    metastaticSolidTumor: state.hospitalAdmissionFormReducer.metastaticSolidTumor,
    metastaticSolidTumorPrimarySite: state.hospitalAdmissionFormReducer.metastaticSolidTumorPrimarySite,
    metastaticSolidTumorMetastaticSites: state.hospitalAdmissionFormReducer.metastaticSolidTumorMetastaticSites,
    leukemia: state.hospitalAdmissionFormReducer.leukemia,
    lymphoma: state.hospitalAdmissionFormReducer.lymphoma,
    hiv: state.hospitalAdmissionFormReducer.hiv,
    hiv_treatment: state.hospitalAdmissionFormReducer.hiv_treatment,
    cysticFibrosis: state.hospitalAdmissionFormReducer.cysticFibrosis,
    bronchiectasis: state.hospitalAdmissionFormReducer.bronchiectasis,
    covid: state.hospitalAdmissionFormReducer.covid,
    febrileNeutropenia: state.hospitalAdmissionFormReducer.febrileNeutropenia,
    no_pre_existing_conditions: state.hospitalAdmissionFormReducer.no_pre_existing_conditions,
    pregnancy: state.hospitalAdmissionFormReducer.pregnancy,
    pregnancy_trimester: state.hospitalAdmissionFormReducer.pregnancy_trimester,
    carbapenemBacterialInfectionHistory: state.hospitalAdmissionFormReducer.carbapenemBacterialInfectionHistory,
    hospitalAdmissionsInPastSixMonths: state.hospitalAdmissionFormReducer.hospitalAdmissionsInPastSixMonths,
    hospitalAdmissionsInPastSixMonthsText: state.hospitalAdmissionFormReducer.hospitalAdmissionsInPastSixMonthsText,
    refractorySepticShock: state.hospitalAdmissionFormReducer.refractorySepticShock,
    transplantWithinNinetyDays: state.hospitalAdmissionFormReducer.transplantWithinNinetyDays,
    traumaSurgery: state.hospitalAdmissionFormReducer.traumaSurgery,
    traumaSurgeryText: state.hospitalAdmissionFormReducer.traumaSurgeryText,
    cytotoxicChemotherapy: state.hospitalAdmissionFormReducer.cytotoxicChemotherapy,
    highDoseCorticosteroids: state.hospitalAdmissionFormReducer.highDoseCorticosteroids,
    recentTravelToForeignCountry: state.hospitalAdmissionFormReducer.recentTravelToForeignCountry,
    recentTravelToForeignCountryText: state.hospitalAdmissionFormReducer.recentTravelToForeignCountryText,
    carbapenemInPriorThirtyDays: state.hospitalAdmissionFormReducer.carbapenemInPriorThirtyDays,
    ventilatorBeforeCulture: state.hospitalAdmissionFormReducer.ventilatorBeforeCulture,
    bacterialInfectionRiskFactorsOther: state.hospitalAdmissionFormReducer.bacterialInfectionRiskFactorsOther,
    bacterialInfectionRiskFactorsOtherText: state.hospitalAdmissionFormReducer.bacterialInfectionRiskFactorsOtherText,
    no_carbapenem_bacterial_infection_risk_factors: state.hospitalAdmissionFormReducer.no_carbapenem_bacterial_infection_risk_factors,

    // PHASE FOUR - INFECTION COURSE/MICROBIOLOGY
    displayInfectionScreeningFailure: state.infectionCourseFormReducer.displayInfectionScreeningFailure,
    infection_course_info_url: state.infectionCourseFormReducer.infection_course_info_url,
    date_of_onset: state.infectionCourseFormReducer.date_of_onset,
    positive_bacterial_culture_results: state.infectionCourseFormReducer.positive_bacterial_culture_results,
    fever: state.infectionCourseFormReducer.fever,
    elevated_inflammatory_markers: state.infectionCourseFormReducer.elevated_inflammatory_markers,
    other_infection_diagnosed: state.infectionCourseFormReducer.other_infection_diagnosed,
    other_infection_diagnosed_description: state.infectionCourseFormReducer.other_infection_diagnosed_description,
    confirmed_or_presumed_primary_source: state.infectionCourseFormReducer.confirmed_or_presumed_primary_source,
    confirmed_or_presumed_primary_source_description: state.infectionCourseFormReducer.confirmed_or_presumed_primary_source_description,
    primary_source_related_to_prosthetic: state.infectionCourseFormReducer.primary_source_related_to_prosthetic,
    device_removed_or_replaced_date: state.infectionCourseFormReducer.device_removed_or_replaced_date,
    primary_source_addressed: state.infectionCourseFormReducer.primary_source_addressed,
    primary_source_addressed_date: state.infectionCourseFormReducer.primary_source_addressed_date,
    primary_source_infection_details: state.infectionCourseFormReducer.primary_source_infection_details,
    other_pathogen_description: state.infectionCourseFormReducer.other_pathogen_description,
    
    // PHASE FIVE - ANTIBIOTICS
    antibioticsUseInfoUrl: state.antibioticsUseFormReducer.antibioticsUseInfoUrl,
    displayAntibioticsScreeningFailure: state.antibioticsUseFormReducer.displayAntibioticsScreeningFailure,
    reasonToStartCefiderocol: state.antibioticsUseFormReducer.reasonToStartCefiderocol,
    reasonToStartCefiderocolOtherText: state.antibioticsUseFormReducer.reasonToStartCefiderocolOtherText,
    cefiderocolInitiationDate: state.antibioticsUseFormReducer.cefiderocolInitiationDate,
    cefiderocolInitiationTime: state.antibioticsUseFormReducer.cefiderocolInitiationTime,
    cefiderocolRecommendedBy: state.antibioticsUseFormReducer.cefiderocolRecommendedBy,
    cefiderocolRecommendedByOtherText: state.antibioticsUseFormReducer.cefiderocolRecommendedByOtherText,
    attendingPhysicianSpecialty: state.antibioticsUseFormReducer.attendingPhysicianSpecialty,
    cefiderocolStartingDoseGrams: state.antibioticsUseFormReducer.cefiderocolStartingDoseGrams,
    cefiderocolInfusionTimeHours: state.antibioticsUseFormReducer.cefiderocolInfusionTimeHours,
    cefiderocolInfusionFrequencyHours: state.antibioticsUseFormReducer.cefiderocolInfusionFrequencyHours,
    patientBodyWeight: state.antibioticsUseFormReducer.patientBodyWeight,
    serumCreatineLevel: state.antibioticsUseFormReducer.serumCreatineLevel,
    serumCreatineLevelUnit: state.antibioticsUseFormReducer.serumCreatineLevelUnit,
    cefiderocolEndDate: state.antibioticsUseFormReducer.cefiderocolEndDate,
    reasonForEndingCefiderocol: state.antibioticsUseFormReducer.reasonForEndingCefiderocol,
    reasonForEndingCefiderocolOtherText: state.antibioticsUseFormReducer.reasonForEndingCefiderocolOtherText,
    patientReceivedOtherAntimicrobials: state.antibioticsUseFormReducer.patientReceivedOtherAntimicrobials,
    clinicalAssessmentCefiderocolTreatment: state.antibioticsUseFormReducer.clinicalAssessmentCefiderocolTreatment,
    gnbiMicrobiologyRepeated: state.antibioticsUseFormReducer.gnbiMicrobiologyRepeated,
    gnbiDateOfSampleTest: state.antibioticsUseFormReducer.gnbiDateOfSampleTest,
    gnbiPathogens: state.antibioticsUseFormReducer.gnbiPathogens,
    deviceRemovedOrReplaced: state.antibioticsUseFormReducer.deviceRemovedOrReplaced,
    deviceRemovedOrReplacedDate: state.antibioticsUseFormReducer.deviceRemovedOrReplacedDate,
    patientExperiencedAdverseEvents: state.antibioticsUseFormReducer.patientExperiencedAdverseEvents,
    patientAdmittedToICU: state.antibioticsUseFormReducer.patientAdmittedToICU,
    cefiderocolAdverseEvents: state.antibioticsUseFormReducer.cefiderocolAdverseEvents,
    additionalAntimicrobials: state.antibioticsUseFormReducer.additionalAntimicrobials,

    // PHASE SIX - HOSPITALIZATION OUTCOME
    patientDied: state.hospitalizationOutcomeFormReducer.patientDied,
    patientDischarged: state.hospitalizationOutcomeFormReducer.patientDischarged,
    dateOfDeath: state.hospitalizationOutcomeFormReducer.dateOfDeath,
    causesOfDeath: state.hospitalizationOutcomeFormReducer.causesOfDeath,
    place_of_residence: state.hospitalizationOutcomeFormReducer.place_of_residence,
    place_of_residence_other_text: state.hospitalizationOutcomeFormReducer.place_of_residence_other_text,
    dateOfDischarge: state.hospitalizationOutcomeFormReducer.dateOfDischarge,
    dischargedWithAntibiotics: state.hospitalizationOutcomeFormReducer.dischargedWithAntibiotics,
    hospitalizationOutcomeUrl: state.hospitalizationOutcomeFormReducer.hospitalizationOutcomeUrl,
  }
}

const mapDispatchToProps = {
  toggleChartRequiresRevisions,
  toggleChartApproved,
  toggleChartCompleted,
  getChart,
  getIncompleteCharts,
  getChartCounts,
  handleChartPhaseChange,
  chartHasBeenCompleted,
  submitChartGeneralInfo,
  submitChartDemographicsInfo,
  submitChartHospitalAdmissionInfo,
  addInfectionCourse,
  submitChartAntibioticsUse,
  submitChartHospitalizationOutcome,
  deleteChart,
  isChartCompleted,
  handleChartFieldChange,
  alertChartHasBeenSaved,
  submitChartPathogenInfo,
  toggleChartApprovedBySite,
  toggleChartApprovedByDataManager,
}

const ChartFormContainerWithAlert = withAlert()(ChartFormContainer)


export default WithAuth(connect(mapStateToProps, mapDispatchToProps)(ChartFormContainerWithAlert))
